import React from 'react';
import Image from 'next/image';
import { Typography } from '@/components/common';
import Images from '@/const/images';
import clsx from 'clsx';

type Categories = 'super-lawyers' | 'preeminent';

interface Props {
	type: Categories;
}

interface Content {
	image: string;
	description: string;
	width: number;
	height: number;
}

export const CardAwards: React.FC<Props> = ({ type }) => {
	const dir: Record<Categories, Content> = {
		'super-lawyers': {
			image: Images.superLawyer,
			description:
				'Through research and peer input, Super Lawyers identifies top attorneys across the nation, from seasoned leaders to Rising Stars.',
			width: 184,
			height: 46,
		},
		preeminent: {
			image: Images.preeminent,
			description:
				'Martindale-Hubbell has evaluated attorneys’ skill and ethics since 1887, offering trusted peer and client-based ratings nationwide.',
			width: 190,
			height: 60,
		},
	};
	const image = dir[type].image;
	const description = dir[type].description;
	const width = dir[type].width;
	const height = dir[type].height;

	return (
		<div
			className={clsx(
				'bg-white border border-[#0D061633] p-10 shadow-shadow2 rounded-[32px] space-y-10 w-fit xl:w-[520px]',
				{
					'!space-y-7': type === 'preeminent',
				}
			)}
		>
			<Image src={image} width={width} height={height} alt="" />
			<Typography type="regular-18">{description}</Typography>
		</div>
	);
};
